/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export const anon = 'No Identificado';

type TUserType = 'TUTOR' | 'COUNSELOR' | 'CENTER' | 'MASTER';
const UserTypeToCName: {[key in TUserType]: string} = {
  TUTOR: "Tutor",
  COUNSELOR: "Orientador",
  CENTER: "Centro",
  MASTER: "Admin"
}

export const getNameByProfile = (userType: TUserType, date: string) =>{
  const usernName = UserTypeToCName[userType] || anon;
  if(!date) return usernName;

  return `${usernName} ${[Number(date) - 1, date ].join('-')}`;
}

export const concatName = (...names: string[]) => {
  const nameArray = names.filter(s => !!s)
  if(!nameArray.length) return '';

  return nameArray.join(' ')
}

export const concatNameOrAnon = (...names: string[]) => {
  return concatName(...names) || anon
}

export const concatNameOrByProfile = ( userType: TUserType, date: string, ...names: string[]) => {
  return concatName(...names) || getNameByProfile(userType, date);
}